module.exports = __webpack_public_path__ + "img/world_animal_protection.084c22b3.svg";